import { Navigate } from 'react-router-dom';

export function DashboardPage() {
  // Redirect to map page as the main dashboard
  return <Navigate to="/dashboard/map" replace />;
}
